import React from "react";
import Icon1 from "../icons/Icon";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useEffect } from "react";
import { useAuth } from "../auth/FirebaseAuth";
import { getUserById } from "../models/UserFunctions";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { useAppContext } from "../config/AppContext";
import PrimaryButton from "../buttons/PrimaryButton";
import TextFieldEmail from "../textfields/TextFieldEmail";
import sendRequest from "../api/send/sendRequest";
import SecondaryButton from "../buttons/SecondaryButton";

const PlanLine = ({ title }) => {
  return (
    <div className="flex flex-row gap-2">
      <Icon1 icon_name="done" height="16px" width="16px" />
      <div className="text-h3">{title}</div>
    </div>
  );
};

const Support = ({ onClose }) => {
  const [userData, setUserData] = useState(null);
  const [orgData, setOrgData] = useState(null);
  const { currentUser, loading } = useAuth();

  const [message, SetMessage] = useState("");

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const handleSendRequest = async () => {
    const token = await getOrRefreshFirebaseToken();
    await sendRequest(
      orgData.id,
      message,
      orgData.email,
      orgData.phone,
      "request",
      token,
      prefix
    );
    handleClickVariant("Message envoyé avec succès", "success");
    onClose();
  };

  const handleFetchData = async () => {
    if (currentUser) {
      try {
        const user = await getUserById(currentUser.uid);
        const org = await getOrgById(user.org_id);

        setUserData(user);
        setOrgData(org);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    if (currentUser) {
      handleFetchData();
    }
  }, [currentUser]);

  if (loading || !currentUser || !userData) {
    return <> Loading ..</>;
  }

  return (
    <div className="bg-white flex flex-col p-4 w-c400 rounded-3xl ">
      <div className="flex flex-col gap-1 w-full">
        <div className="text-h3 text-shadow_50">
          Message à destination du support{" "}
          <span className="text-indigo-400 font-semibold">hexagone</span>
        </div>
        <div className="text-h3 text-shadow_50 mt-2">
          Vous êtes au bon endroit si vous voulez signaler un{" "}
        </div>
        <ul className="list-disc text-h3 text-shadow_50 ml-4">
          <li>Bug</li>
          <li>Suggestion</li>
          <li>Incompréhension</li>
        </ul>
        <div className="text-h3 text-shadow_50 my-2">
          Si vous avez une demande spécifique pour votre partenaire, merci
          d'utiliser le{" "}
          <span className="text-indigo-400 font-semibold">
            chat du dossier.
          </span>
        </div>
        <TextFieldEmail
          border_forced={true}
          label="Message"
          value={message}
          onChange={(e) => SetMessage(e.target.value)}
        ></TextFieldEmail>
        <div className="w-full justify-end gap-2 flex mt-2">
          <SecondaryButton className="w-fit" onClick={onClose}>
            Annuler
          </SecondaryButton>
          <PrimaryButton className="w-fit" onClick={handleSendRequest}>
            Envoyer au support hexagone
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default Support;
